// extracted by mini-css-extract-plugin
module.exports = {"share-component-wrapper":"share_share-component-wrapper__3Zg_z","name-tag":"share_name-tag__23OaP","invalid-tag":"share_invalid-tag__1_2kX"};